import { Form, Modal } from "react-bootstrap";
import "./Coupons_Modal.css";
import Green_Check_Lottie from "../../../Animation/green_check_lottie/Green_Check_Lottie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { useDispatch, useSelector } from "react-redux";
import { getCoupons } from "../../../../features/home/homeSlice";
import { useEffect, useState } from "react";
import { CouponApplyed } from "../../../../features/order/orderSlice";

const Coupons_Modal = ({
  setValue,
  setCouponData,
  setCouponError,
  onSubmit,
  data,
  ...props
}) => {
  const dispatch = useDispatch();
  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    

    dispatch(getCoupons({ amount: data?.order_summary?.total_selling_price }));
  }, [dispatch, data]);

 

  const handelSubmit = async (val) => {
    const res = await dispatch(
      CouponApplyed({
        code: val.code,
        amount: data?.order_summary?.total_selling_price,
      }),
    );

    // Close modal immediately
    props.onHide();

    if (res?.payload?.data) {
      setCouponError("");
      setCouponData(res.payload.data);
      setValue("code", val.code);
    } else {
      setCouponError(res?.payload?.errors || "Unable to apply coupon");
    }
  };

  return (
    <Modal className="Coupons_Modal" size="lg" {...props} centered>
      <Modal.Header closeButton>
        <div className="title_div">
          <FontAwesomeIcon icon={faTags} className="tag_icon" />
          <p className="title_text">Coupons</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="coupons_holder">
          {/* {coupons?.data?.length <= 0 && "Coupon Not available"} */}
          {(!coupons?.data || coupons.data.length === 0) && (
            <div className="text-black">No Coupons Available</div>
          )}
          {coupons?.data?.map((val) => (
            <div className="coupon_div">
              <p className="coupon_title">{val?.name}</p>
              <p className="text-dark mt-1">{val?.code}</p>
              <p className="free_text">
                {/* Get 1 item for free{" "} */}
                <span className="save_text">
                  Save ₹
                  {val?.Discount_Type?.id === 2
                    ? (
                        ((data?.order_summary?.total_selling_price || 0) *
                          (val?.discount || 0)) /
                        100
                      ).toFixed(2)
                    : parseFloat(val?.discount || 0).toFixed(2)}{" "}
                  on this order!
                </span>
              </p>

              <div className="offer_div">
                <ul>
                  <li className="offer_text">
                    Flat{" "}
                    {val?.Discount_Type?.id === 2
                      ? `${val?.discount}%`
                      : val?.discount}{" "}
                  </li>
                  <li className="offer_text">
                    Valid on minimum purchase of ₹{val?.required_amount}{" "}
                  </li>
                  <li className="offer_text">{val?.message} </li>
                  <li className="offer_text">{val?.info}</li>
                </ul>
              </div>

              <div className="apply_btn_holder">
                <Green_btn
                  btnText={"Apply"}
                  onClick={() => handelSubmit(val)}
                />
              </div>
            </div>
          ))}
        </div>

        {/* <div className="coupons_holder">
          <div className="coupon_div">
            <p className="coupon_title">F2KG</p>
            <p className="free_text">
              Get 1 item for free{" "}
              <span className="save_text">Save ₹469 on this order!</span>
            </p>

            <div className="offer_div">
              <ul>
                <li className="offer_text">Flat 100% off on 1 item </li>
                <li className="offer_text">
                  Valid on minimum purchase of ₹2000.0{" "}
                </li>
                <li className="offer_text">
                  Cannot be combined with other discounts{" "}
                </li>
                <li className="offer_text">Valid on specific items</li>
              </ul>
            </div>

            <div className="apply_btn_holder">
              <Green_btn btnText={"Apply"} />
            </div>
          </div>
        </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default Coupons_Modal;
